import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Landmark, Link2, CheckCircle2, AlertTriangle, Copy } from "lucide-react";
import { api } from "../lib/api";

function UrlRow({ label, value, testid }) {
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label} copiada`);
    } catch {
      toast.info(value);
    }
  }
  return (
    <div className="flex items-center gap-2 rounded-md bg-black/40 border border-white/10 px-2.5 py-1.5">
      <span className="text-[10px] uppercase tracking-widest text-neutral-500 shrink-0">{label}</span>
      <span className="font-mono text-[11px] text-white break-all flex-1" data-testid={testid}>{value}</span>
      <button onClick={copy} data-testid={`${testid}-copy`} className="shrink-0 px-2 py-1 rounded bg-white/5 hover:bg-white/10 text-[11px] flex items-center gap-1">
        <Copy className="w-3 h-3" /> Copiar
      </button>
    </div>
  );
}

export default function ChytaPayAdminCard() {
  const [st, setSt] = useState(null);

  useEffect(() => {
    api.get("/admin/chytapay/status").then(({ data }) => setSt(data)).catch(() => setSt({ error: true }));
    const q = new URLSearchParams(window.location.search).get("chytapay");
    if (q === "ok") toast.success("ChytaPay conectado");
    else if (q) toast.error("No se pudo conectar ChytaPay, intentá de nuevo");
  }, []);

  async function connect() {
    try {
      const { data } = await api.get("/admin/chytapay/connect");
      window.location.href = data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    }
  }

  if (!st || st.error) return null;
  const ready = st.connected && st.webhook_secret;
  return (
    <div data-testid="chytapay-admin-card" className={`mb-6 rounded-xl border p-4 ${ready ? "border-emerald-500/30 bg-emerald-500/5" : "border-amber-400/40 bg-amber-400/5"}`}>
      <div className="flex flex-wrap items-center gap-3">
        <Landmark className="w-5 h-5 text-[#ff4500]" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-white flex items-center gap-2">
            ChytaPay <span className="text-[10px] uppercase tracking-widest px-1.5 py-0.5 rounded bg-white/10" data-testid="chytapay-env">{st.environment}</span> {ready ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <AlertTriangle className="w-4 h-4 text-amber-300" />}
          </div>
          <div className="text-xs text-neutral-400" data-testid="chytapay-admin-status">
            {!st.credentials ? "Faltan las credenciales" : st.connected ? `Conectado: ${st.merchant?.fantasyName || st.merchant?.accountHolderName || "comercio"}` : "Credenciales cargadas, falta conectar la cuenta de comercio"}
            {!st.webhook_secret && " · falta el secreto del webhook"}
          </div>
        </div>
        {st.credentials && (
          <button onClick={connect} data-testid="chytapay-connect-btn" className="btn-primary px-3 py-2 rounded-md text-sm flex items-center gap-1.5">
            <Link2 className="w-4 h-4" /> {st.connected ? "Reconectar" : "Conectar ChytaPay"}
          </button>
        )}
      </div>
      <div className="mt-3 space-y-1.5">
        <p className="text-[11px] text-neutral-400">Registrá estas direcciones <b>exactas</b> en el portal de ChytaPay ({st.environment === "produccion" ? "ambiente Producción" : "ambiente Sandbox"}) → Configuración:</p>
        <UrlRow label="Redirect URI" value={st.redirect_uri} testid="chytapay-redirect-uri" />
        <UrlRow label="Webhook URL" value={st.webhook_url} testid="chytapay-webhook-url" />
      </div>
    </div>
  );
}
